export default "__VITE_ASSET__DNz38BoO__"